(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningLevelController', WarningLevelController);

    WarningLevelController.$inject = ['entity','$uibModalInstance', 'Warning'];

    function WarningLevelController(entity, $uibModalInstance, Warning) {
        var vm = this;
        vm.warning = entity;

        vm.criticals = [
            {id: 1, name: "1 - LOW"},
            {id: 2, name: "2 - CRITICAL"}
            ];

        vm.critical = vm.criticals.find(function (value) {
            return value.id === vm.warning.critical;
        });

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.update = function () {
            vm.warning.critical  = vm.critical.id;
            vm.warning.active = !vm.warning.active;
            vm.warning.critical  = vm.critical.id;
            Warning.update(vm.warning);
            vm.clear();
        }
    }
})();
